import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import { CURD_QUESTION_RATING_VALUE } from "../../utils/routes";

// ---------------------------------------------------------------------

export const createQuestionRatingValue = createAsyncThunk(
  "questionRatingValue/createQuestionRatingValue",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_QUESTION_RATING_VALUE, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getQuestionRatingValue = createAsyncThunk(
  "questionRatingValue/getQuestionRatingValue",
  async () => {
    return axios.get(CURD_QUESTION_RATING_VALUE, { withCredentials: true });
  }
);

export const updateQuestionRatingValue = createAsyncThunk(
  "questionRatingValue/updateQuestionRatingValue",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_QUESTION_RATING_VALUE, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteQuestionRatingValue = createAsyncThunk(
  "questionRatingValue/deleteQuestionRatingValue",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_QUESTION_RATING_VALUE, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const questionRatingValueSlice = createSlice({
  name: "questionRatingValue",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    questionRatingValueData: [],
    selectedData: {},
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    rowSelect: (state, action) => {
      state.selectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createQuestionRatingValue.pending]: (state, action) => {
      state.loading = true;
    },
    [createQuestionRatingValue.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createQuestionRatingValue.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getQuestionRatingValue.pending]: (state, action) => {
      state.loading = true;
    },
    [getQuestionRatingValue.fulfilled]: (state, action) => {
      state.loading = false;
      state.questionRatingValueData = action?.payload?.data;
    },
    [getQuestionRatingValue.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateQuestionRatingValue.pending]: (state, action) => {
      state.loading = true;
    },
    [updateQuestionRatingValue.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateQuestionRatingValue.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteQuestionRatingValue.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteQuestionRatingValue.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteQuestionRatingValue.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, rowSelect } =
  questionRatingValueSlice.actions;
export default questionRatingValueSlice.reducer;
